declare global {
	interface Window {
		dataLayer?: object[];
	}
}

export function dataLayerPush<T extends object>(value: T) {
	(window.dataLayer ??= []).push(value);
}
